import { styled } from '@mui/material'
import { Link, LinkProps } from 'react-router-dom'

export const RouterLink = styled(Link)<LinkProps>(() => ({
  all: 'unset',
  cursor: 'pointer',
}))
